import { render } from "./FolderElem.vue?vue&type=template&id=279fc3f0"
import script from "./FolderElem.vue?vue&type=script&lang=js"
export * from "./FolderElem.vue?vue&type=script&lang=js"

import "./FolderElem.vue?vue&type=style&index=0&id=279fc3f0&lang=css"

import exportComponent from "/home/user/ade-home/chantiervocal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__